module.exports = __webpack_public_path__ + "static/media/GolosText-Regular.cda9e1cd.ttf";